import {useDispatch, useSelector} from 'react-redux';

import LoginForm from './LoginForm';
import {motion, AnimatePresence} from "framer-motion";
import {authAnimation} from '../../animations';
import AuthHeader from './AuthHeader';

import {updateSidebarMode} from '../../actions/updateSidebarMode';
import SaveOrLoad from './SaveOrLoad';

import SmileGoogleLogin from  './Socials/SmileGoogleLogin';
import SmileFacebookLogin from  './Socials/SmileFacebookLogin';

const Login = () => {

    const {user} = useSelector((state) => state.user)

    const dispatch = useDispatch();

    const registerHandler = () => {

        dispatch( updateSidebarMode( 'register' ) );
    }

    return (
        <motion.div
        layoutId="auth"
        key="login"
        variants={authAnimation}
        initial="initial"
        animate="visible"
        exit="exit">

            <AnimatePresence exitBeforeEnter>
                {
                    false === user.jwtAuthToken ? (
                        <motion.div
                        variants={authAnimation}
                        initial="initial"
                        animate="visible"
                        exit="exit"
                        layoutId="shareLogin"
                        key="shareLogin">
                            <AuthHeader />
                            <LoginForm />

                            <p className="inline-or">OR</p>

                            <SmileGoogleLogin text="Login with Google"/>
                            <SmileFacebookLogin text="Login with Facebook"/>


                            <p className="inline-or is-7">Need an account? <button onClick={registerHandler} className="is-family-secondary cursor btn">Sign Up</button></p>
                        </motion.div>
                    ) : (
                        <motion.div
                        variants={authAnimation}
                        initial="initial"
                        animate="visible"
                        exit="exit"
                        layoutId="shareLogin"
                        key="saveLoad">
                            <SaveOrLoad/>
                        </motion.div>
                    )
                }
            </AnimatePresence>

        </motion.div>
    );
}

export default Login;